import { CircularProgress } from '@material-ui/core';

const CircularProgressButton = () => <CircularProgress size={20} color='secondary' thickness={5} />;

export default CircularProgressButton;